import {Component, OnInit, SimpleChanges} from "@angular/core";
import {Subscription} from "rxjs";
import {ConfirmationService} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {
    ObjectBaseModeComponent
} from "../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {ObserverService} from "../../../../../../../core/shared/object/service/observer.service";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";

@Component({
    selector: "um-role-object-view",
    template: '',
    standalone: false
})

export class UmRoleObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    busy: boolean; // Indicator whether the component is busy
    initialized: boolean; // Indicator whether the component was initialized

    roleAuthModuleWidget: WidgetData;
    roleAuthObjectTypeWidget: WidgetData;
    roleAuthContractWidget: WidgetData;
    roleAuthCustomerWidget: WidgetData;
    roleAuthCustomerRegionWidget: WidgetData;
    roleAuthCustomerTypeWidget: WidgetData;
    roleAuthQueryStartWidget: WidgetData;

    queryParamSubscription: Subscription;

    roleWidgetData: WidgetData;

    navigationItems: NavigationItem[] = [
        {
            label: 'Role Data',
            action: 'RoleData',
            icon: 'pi pi-fw pi-id-card',
            toggleable: false,
            default: true
        },
        {
            label: 'Module',
            action: 'Module',
            icon: 'pi pi-fw pi-sitemap',
            toggleable: false
        },
        {
            label: 'ObjectType',
            action: 'ObjectType',
            icon: 'pi pi-fw pi-th-large',
            toggleable: false
        },
        {
            label: 'Query Start',
            action: 'QueryStart',
            icon: 'fa-thin fa-circle-play',
            toggleable: false
        },
        {
            label: 'Contract',
            action: 'Contract',
            icon: 'pi pi-fw pi-file',
            toggleable: false
        },
        {
            label: 'Customer',
            action: 'Customer',
            icon: 'pi pi-fw pi-users',
            toggleable: false
        }
    ];

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected router: Router,
        protected observerService: ObserverService
    ) {
        super(route);
    }

    ngOnInit(): void {

        this.handleNavigationItems();
        this.onNavigationItems.emit(this.navigationItems);
        super.ngOnInit();


        this.initComponent();
    }

    handleNavigationItems() {
        this.activeNavigationItem = this.navigationItems[0];
    }


    refreshRoleWidget() {
        this.roleWidgetData = WidgetFactory.createWidgetEntityData(
            'um.role.object.base.component.role.widget',
            'Role',
            'um.Role',
            this.objectIdentifier.objectId
        );
    }


    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.loadRoleAuthModule();
        this.loadRoleAuthObjectType();
        this.loadRoleAuthContract();
        this.loadRoleAuthCustomer();
        this.refreshRoleWidget();
        this.loadRoleAuthQueryStart();
        this.initialized = true;
    }

    loadRoleAuthQueryStart() {
        this.roleAuthQueryStartWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'um.role.auth.query.start.widget',
            'Auth query start',
            'um.RoleAuthModuleQueryStart', [
            FilterCriteria.create(
                "e.roleId",
                FilterCriteria.cOperatorEqual,
                this.objectIdentifier.objectId
            )
            ]
        )
    }

    loadRoleAuthModule() {

        this.roleAuthModuleWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'um.role.auth.module.widget.new',
            'Auth module',
            'um.RoleAuthModule', [
            FilterCriteria.create(
                "e.roleId",
                FilterCriteria.cOperatorEqual,
                this.objectIdentifier.objectId
            )
        ]
        );

    }




    loadRoleAuthObjectType() {
        this.roleAuthObjectTypeWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl('um.role.auth.object.base.type.widget', 'Auth object type', 'um.RoleAuthObjectType', [
            FilterCriteria.create(
                "e.roleId",
                FilterCriteria.cOperatorEqual,
                this.objectIdentifier.objectId
            )
        ], []);

    }

    loadRoleAuthContract() {

        this.roleAuthContractWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl('um.role.auth.contract.object.base.widget', 'Auth contract', 'cm.RoleAuthContract', [
            FilterCriteria.create(
                "e.roleId",
                FilterCriteria.cOperatorEqual,
                this.objectIdentifier.objectId
            )
        ], []);

    }

    loadRoleAuthCustomer() {

        this.roleAuthCustomerWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'um.role.auth.customer.widget',
            'Auth customer',
            'cr.RoleAuthCustomer',
            [FilterCriteria.create(
                'e.roleId',
                FilterCriteria.cOperatorEqual,
                this.objectIdentifier.objectId
            )]
        );

    }

    handleObjectSelect(objectData: ObjectIdentifierData | ObjectIdentifier) {

        this.roleAuthCustomerRegionWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'um.role.auth.customer.region.widget',
            'Auth customer region',
            'cr.RoleAuthCustomerRegion',
            [FilterCriteria.create(
                'e.roleAuthCustomerId',
                FilterCriteria.cOperatorEqual,
                objectData.objectId
            )]
        );

        this.roleAuthCustomerTypeWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'um.role.auth.customer.type.widget',
            'Auth customer type',
            'cr.RoleAuthCustomerType',
            [FilterCriteria.create(
                'e.roleAuthCustomerId',
                FilterCriteria.cOperatorEqual,
                objectData.objectId
            )]
        );
    }

    resetWidgets() {
        this.roleAuthCustomerRegionWidget = null;
        this.roleAuthCustomerTypeWidget = null;
    }

    handleNavigationItemsChange() {
        this.resetWidgets();
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
    }

}
